module.exports = __webpack_public_path__ + "static/noise-c02ffaf2762a4da13c61c645f54f4927.png";